import { TextBold } from "ui";

import InlineEllipsis from "@/components/InlineEllipsis/";
import { useOrganization } from "@/utils/api/useOrganization";

import { Container, Loader, Logo } from "./_loadingScreenStyle";

type LoadingScreenProps = {
  withLogo?: boolean;
  text?: string;
};

function LoadingScreen({ withLogo = true, text = "Loading" }: LoadingScreenProps) {
  const { organization } = useOrganization();

  return (
    <Container className="loading-screen-container">
      {withLogo && <Logo src={organization.logo_url ?? undefined} />}
      <Loader />
      <TextBold size="h-m" mt={24} textAlign="center">
        {text}
        <InlineEllipsis />
      </TextBold>
    </Container>
  );
}

export default LoadingScreen;
